import React, { useState } from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaApple,
  FaGooglePlay,
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { toast } from "react-toastify";
import { useTranslation } from "../hooks/useTranslation";

const Footer = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address");
      return;
    }
    setEmailError("");
    setEmail("");
    toast.success("Subscribed successfully!");
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1E1E1E] text-[#F5F5F5] py-12 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
        <div className="space-y-4">
          <h3 className="text-xl font-bold text-[#D4AF37]">
            {t("companyInfo")}
          </h3>
          <ul className="space-y-2">
            {[
              { label: t("aboutUs"), url: "/about_us" },
              { label: t("careers"), url: "/Careers" },
              { label: t("blog"), url: "/blog" },
              { label: t("contactUs"), url: "/Contact" },
            ].map((item) => (
              <li key={item.label}>
                <a
                  href={item.url}
                  className="text-[#F5F5F5] hover:text-[#D4AF37] transition-colors duration-300 relative group no-underline"
                >
                  {item.label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#D4AF37] transition-all duration-300 group-hover:w-full"></span>
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-bold text-[#D4AF37]">
            {t("supportHelp")}
          </h3>
          <ul className="space-y-2">
            {[
              { label: t("faqs"), url: "/faqs" },
              { label: t("customerSupport"), url: "/CustomerSupport" },
              { label: t("termsConditions"), url: "/TermsConditions" },
              { label: t("privacyPolicy"), url: "/PrivacyPolicy" },
              { label: t("cancellationPolicy"), url: "/CancellationPolicy" },
            ].map((item) => (
              <li key={item.label}>
                <a
                  href={item.url}
                  className="text-[#F5F5F5] hover:text-[#D4AF37] transition-colors duration-300 relative group no-underline"
                >
                  {item.label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#D4AF37] transition-all duration-300 group-hover:w-full"></span>
                </a>
              </li>
            ))}
          </ul>

          {/* Payment Policies (Razorpay) */}
          <div className="mt-4 pt-4 border-t border-[#2A2A2A]">
            <p className="text-xs text-gray-500 mb-2 uppercase tracking-wider">Payment Policies</p>
            <ul className="space-y-1">
              {[
                { label: "Terms of Service",  url: "https://merchant.razorpay.com/policy/SPsvK9DBdcaq6F/terms" },
                { label: "Privacy Policy",    url: "https://merchant.razorpay.com/policy/SPsvK9DBdcaq6F/privacy" },
                { label: "Refund Policy",     url: "https://merchant.razorpay.com/policy/SPsvK9DBdcaq6F/refund" },
                { label: "Shipping Policy",   url: "https://merchant.razorpay.com/policy/SPsvK9DBdcaq6F/shipping" },
                { label: "Contact Us",        url: "https://merchant.razorpay.com/policy/SPsvK9DBdcaq6F/contact_us" },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-gray-400 hover:text-[#D4AF37] transition-colors duration-300 no-underline"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-bold text-[#D4AF37]">
            {t("exploreMore")}
          </h3>
          <ul className="space-y-2">
            {[
              { label: t("hotelsNearMe"), url: "/HotelRoomsPage" },
              { label: t("popularDestinations"), url: "/travel" },
              { label: t("partnerWithUs"), url: "PartnerWithUs" },
              { label: t("corporateBookings"), url: "CorporateBookings" },
            ].map((item) => (
              <li key={item.label}>
                <a
                  href={item.url}
                  className="text-[#F5F5F5] hover:text-[#D4AF37] transition-colors duration-300 relative group no-underline"
                >
                  {item.label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#D4AF37] transition-all duration-300 group-hover:w-full"></span>
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-bold text-[#D4AF37]">
            {t("quickLinks")}
          </h3>
          <ul className="space-y-2">
            {[
              { label: t("signInSignUp"), url: "/Signup" },
              { label: t("membershipFooter"), url: "/Membership" },
              { label: t("travelGuides"), url: "/TravelGuides" },
            ].map((item) => (
              <li key={item.label}>
                <a
                  href={item.url}
                  className="text-[#F5F5F5] hover:text-[#D4AF37] transition-colors duration-300 relative group no-underline"
                >
                  {item.label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#D4AF37] transition-all duration-300 group-hover:w-full"></span>
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="space-y-6">
          <div>
            <h3 className="text-xl font-bold text-[#D4AF37] mb-4">
              {t("newsletter")}
            </h3>
            <form onSubmit={handleEmailSubmit} className="space-y-3">
              <div>
                <div className="relative">
                  <MdEmail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={t("enterEmail")}
                    className="w-full pl-10 pr-3 py-2 bg-[#2A2A2A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
                    aria-label="Email subscription"
                  />
                </div>
                {emailError && (
                  <p className="text-red-100 text-sm">{emailError}</p>
                )}
              </div>
              <button
                type="submit"
                className="w-full bg-[#D4AF37] text-black py-2 rounded-md hover:bg-[#B89B30] transition-colors duration-300"
              >
                {t("subscribe")}
              </button>
            </form>
          </div>

          <div>
            <h3 className="text-xl font-bold text-[#D4AF37] mb-4">
              {t("connectWithUs")}
            </h3>
            <div className="flex space-x-4">
              {[
                {
                  icon: FaFacebookF,
                  label: "Facebook",
                  url: "https://www.facebook.com/profile.php?id=61574583771198",
                },
                {
                  icon: FaTwitter,
                  label: "Twitter",
                  url: "https://www.twitter.com",
                },
                {
                  icon: FaInstagram,
                  label: "Instagram",
                  url: "https://www.instagram.com/trivanahospitality?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
                },
                {
                  icon: FaLinkedinIn,
                  label: "LinkedIn",
                  url: "https://www.linkedin.com/company/trivana-hospitality/posts/?feedView=all",
                },
                {
                  icon: FaYoutube,
                  label: "YouTube",
                  url: "https://www.youtube.com/@TrivanaHospitality",
                },
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="p-2 bg-[#2A2A2A] rounded-full hover:bg-[#D4AF37] hover:text-black transition-all duration-300 transform hover:scale-110 inline-flex items-center justify-center"
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold text-[#D4AF37] mb-4">
              {t("downloadApp")}
            </h3>
            <div className="flex space-x-4">
              <button className="flex items-center space-x-2 bg-[#2A2A2A] px-4 py-2 rounded-md hover:bg-[#D4AF37] hover:text-black transition-colors duration-300">
                <FaApple className="w-6 h-6" />
                <span>{t("ios")}</span>
              </button>
              <button className="flex items-center space-x-2 bg-[#2A2A2A] px-4 py-2 rounded-md hover:bg-[#D4AF37] hover:text-black transition-colors duration-300">
                <FaGooglePlay className="w-6 h-6" />
                <span>{t("android")}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-[#2A2A2A] text-center">
        <p className="text-sm text-gray-400">
          Powered by Trivana Hospitality | © {currentYear} Booktrivana.com |
          All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
